import { snakeCase } from 'lodash';

export enum TaskEvents {
  OpenTaskDrawer = 'open_task_drawer',
  TaskUpdate = 'task_update',
  TaskCreate = 'task_create',
  TaskDelete = 'task_delete',
  BulkTaskUpdate = 'bulk_task_update',
  DependentTaskCreate = 'dependent_task_create',
  DependentTaskDelete = 'dependent_task_delete',
}

export const TaskEventsMap: Record<string, string> = Object.keys(
  TaskEvents,
).reduce((acc, key) => {
  acc[snakeCase(key).toUpperCase()] = TaskEvents[key];

  return acc;
}, {} as Record<string, string>);
